import { useState } from "react"

export const useFormErrors = (getErrors, getLiveErrors) => {

    const [validatedFields, setValidatedFields] = useState([])

    const liveErrors = (getLiveErrors) ? getLiveErrors() : {}
    const errors = { ...getErrors(), ...liveErrors }

    const errorOf = (name) => ((validatedFields.includes(name)) ? errors[name] : liveErrors[name]) ?? null

    const validate = () => {
        const failedFields = Object.keys(errors)
        setValidatedFields(prevFields => [...prevFields, ...failedFields.filter(name => !prevFields.includes(name))])
        return failedFields.length === 0
    }

    const reset = () => setValidatedFields([])

    return { errorOf, validate, reset }
}
